import { DeleteOutlined } from '@ant-design/icons'
import ButtonComponent from '@BUP/components/Generics/Buttons/button-component'
import ModalComponent from '@BUP/components/Generics/Modal'
import { useDeleteRegistrations } from '@BUP/hooks/registration/useDeleteRegistrations'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './remove_teacher_button.module.scss'

const RemoveTeacherButton = ({ isMultiCourse, user }) => {
  const i18n = useTranslation()
  const [stateModal, setStateModal] = useState(false)
  const [selectedTeacher, setSelectedTeacher] = useState(null)
  const {
    deleteRegistrations,
    loading
  } = useDeleteRegistrations()

  const handleDeleteRegistrations = registrationId => {
    deleteRegistrations(registrationId)
  }

  const handleOpenModal = user => {
    setSelectedTeacher(user)
    setStateModal(true)
  }

  return (
    <>
      <ButtonComponent
        colorType='secondary'
        buttonText={<DeleteOutlined />}
        onClick={() => handleOpenModal(user)}
        size='small'
        disabled={!!isMultiCourse}
      />
      <ModalComponent
        header
        headerText={i18n.t('pages.MySchool.registration.destroy.title', { context: 'main-teacher' })}
        modalDescription={
          <div className={styles.modal_description_wrapper}>
            <h4>
              {i18n.t('pages.MySchool.registration.destroy.description', { context: 'main-teacher' })}
            </h4>
            <ButtonComponent
              buttonText={i18n.t('pages.MySchool.registration.destroy.button.text')}
              loading={loading}
              colorType='secondary'
              onClick={() => handleDeleteRegistrations(selectedTeacher.registrationId)}
              block={false}
            />
          </div>
        }
        stateModal={stateModal}
        showButtons={false}
        onClickCloseModal={() => setStateModal(false)}
      />
    </>
  )
}

export default RemoveTeacherButton
